/**
 * This allows us to recieve the same props as a context provider without throwing errors
 * This has no impact on the running code, but is seamless to an actual provider
 * @param param0
 * @returns
 */
export const MockContextProvider = ({ children }: { widgetId: string; children: React.ReactElement }) => <>{children}</>;
